/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: chen
 *  创建时间: 2026-08-10 09:57
 *  文件名: src/pages/other-resource-list/video-resource-list/index.tsx
 *  功能描述:
 */
import React from 'react';
import './index.less';
import EmptyList from '../../../components/Empty';
import { VideoResourceItem, VideoResourceType, videoResourceTypes } from '../types';
import moment from 'moment';
import { Divider } from 'antd';

interface VideoResourceListProps<T extends VideoResourceType> {
  items: VideoResourceItem<T>[];
  type: T;
  onWatch: (item: VideoResourceItem<T>) => void;
}

/**
 * 获取资源关联的老师名称
 */
function getTeacherNames(item: VideoResourceItem) {
  return 'teacherName' in item ? item.teacherName : '';
}

/**
 * 获取资源时间
 */
function getResourceTime(item: VideoResourceItem) {
  return 'releaseTime' in item ? item.releaseTime : item.applyStartTime;
}

function VideoResourceList<T extends VideoResourceType>(props: VideoResourceListProps<T>) {
  const { items, type, onWatch } = props;

  if (!items.length) {
    return <EmptyList state="noResult" />;
  }

  return (
    <div className="video-resource-list">
      {/* <div className="video-resource-list-content">
        {items.map((item: VideoResourceItem) => (
          <VideoResourceCard key={item.id} data={item} type={type} onWatch={onWatch} />
        ))}
      </div> */}

      {items.map((item) => (
        <div className="video-resource-list-item" key={item.id} onClick={() => onWatch(item)}>
          <div className="video-resource-list-item-header">
            <div className="video-resource-list-item-header-title">
              {videoResourceTypes.find((item) => item.value === type)?.name}
            </div>
            <div
              className="video-resource-list-item-header-name"
              title={item.name}
              dangerouslySetInnerHTML={{ __html: item.highLightName || item.name }}
            />
          </div>
          <div className="video-resource-list-item-content">
            <div className="video-resource-list-item-content-teacher-name">
              老师：{getTeacherNames(item)}
            </div>
            <Divider
              type="vertical"
              style={{
                backgroundColor: '#595959',
              }}
            />
            <div className="video-resource-list-item-content-update-time">
              时间：{moment(getResourceTime(item)).format('YYYY-MM-DD HH:mm')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export { VideoResourceList };
